import { Injectable } from "@angular/core"
import { LangService } from "./lang.service"
import { Subject } from "rxjs"

@Injectable({
	providedIn: "root",
})
export class ModalService {
	miscModalsSubj: any = new Subject()
	toastSubj: any = new Subject()
	openCloseSubj = new Subject()
	stack: any[] = []

	onInit(modal: any) {
		this.stack = [...this.stack, modal]
		return this.stack.length
	}
	onDestroy(modal: any) {
		this.stack = this.stack.filter((it) => it !== modal)
	}
	closeTop() {
		if (!this.stack.length) {
			return false
		}
		this.stack.at(-1)?.close()
	}

	openToast(message: string) {
		this.toastSubj.next(message)
	}
}
